import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPost,
} from "../../utils/fetchUtils";
import {
  GET_BOOKS,
  GET_BOOKS_BY_CAT,
  GET_USER_INFO,
} from "../../utils/constants";
import { IBook } from "../../utils/types";
import BookList from "../../components/BookList";
import Header from "../../components/Header";
import Pagination from "../../components/Pagination";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import BookShelf from "../BookShelf/BookShelf";
import CategoryPage from '../../components/CategoryPage/CategoryPage';

const Library = () => {
  const navigate = useNavigate();
  const [books, setBooks] = useState<IBook[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalBooks, setTotalBooks] = useState(0);
  const [displayStatus, setDisplayStatus] = useState<
    "all" | "category" | "search" | "shelf"
  >("all");
  const [title, setTitle] = useState("All Books");
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [shelf, setShelf] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('Hindi');

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  const categories = [
    // "News",
    // "Latest arrivals",
    // "Fiction",
    // "Nonfiction",
    // "Children Books",
    "School Textbooks",
    // "University textbooks",
    // "Competitive Exams preparation material",
    // "Information related to disability",
  ];

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined || localStorage.getItem("scope") !== 'library'
    ) {
      navigate("/login");
    }
    document.title = "Nclude Library - Nclude Portal";
    fetchBooks();
  }, []);

  useEffect(() => {
    if (displayStatus === "all") fetchBooks();
    else if (displayStatus === "category") fetchBooksByCategory();
  }, [page]);

  const fetchBooks = async (query = "") => {
    try {
      const url = query
        ? `${GET_BOOKS}?search=${query}&page=${page}&limit=${limit}`
        : GET_BOOKS + `?page=${page}&limit=${limit}`;
      const response = await makeAuthenticatedGet(url);
      const temp = response;
      // console.log(temp);
      setTotalBooks(temp.totalBooks);
      setBooks(temp.books);
      setTotalPages(Math.floor((temp.totalBooks - 1) / limit) + 1);
    } catch (error: any) {
      if (error.response && error.response.data) {
        setMessage(error.response.data.message);
      }
      console.error("Error fetching books: ", error);
    }
  };

  const fetchBooksByCategory = async () => {
    try {
      const url = GET_BOOKS_BY_CAT + `?page=${page}&limit=${limit}`;
      const response = await makeAuthenticatedPost(
        url,
        JSON.stringify({ category: category })
      );
      // console.log(response);
      setTotalBooks(response.totalBooks);
      setBooks(response.books);
      setTotalPages(Math.floor((response.totalBooks - 1) / limit) + 1);
    } catch (error: any) {
      console.error("Error fetching books: ", error);
      if (error.response && error.response.data) {
        setMessage(error.response.data.message);
      }
      setMessage(error.message);
    }
  };

  const handleBookSearch = async () => {
    setPage(1);
    setDisplayStatus("all");
    // setTitle("Search Results....");
    if (category === "") {
      fetchBooks(searchQuery);
    } else {
      fetchBooksByCategory();
    }
  };

  const handleAllBooksDisplay = async () => {
    setTitle("All Books");
    setPage(1);
    setDisplayStatus("all");
    setShelf(false);
    await fetchBooks();
  };

  const handleCategoryBooksDisplay = () => {
    setTitle("");
    setPage(1);
    setDisplayStatus("category");
    setBooks([]);
    setShelf(false);
  };

  const handleCategorySearch = async () => {
    // setTitle(category);
    await fetchBooksByCategory();
  };

  const handleLeftPaginationClick = async () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  const handleRightPaginationClick = async () => {
    const maxPage = Math.floor((totalBooks - 1) / limit) + 1;
    // console.log(maxPage);
    if (page < maxPage) {
      setPage((prev) => prev + 1);
    }
  };

  const onPageChange = (newPage: any) => {
    if (newPage < 1 || newPage > totalPages) return; // Prevent going out of bounds
    setPage(newPage);
  };

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="">
      {!isMobile && <Header activePage='lib' curr={0} setShelf={setShelf} />}
      <div className="page-container">
        <SideBar activePage="Library" />
        {isMobile && <header className="mobile-header">
          <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
            <button type="button" tabIndex={0} onClick={() => setShelf(false)} className={shelf ? "" : "active-accessibility-header"}>{'Browse All Books'}</button>
            <button type="button" tabIndex={0} onClick={() => setShelf(true)} className={shelf ? "active-accessibility-header" : ""}>Book Shelf</button>
          </div>
        </header>}
        <div className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile ? "2rem" : "" }}>
          <header>


            <h1 className="display-title" ref={mainRef} tabIndex={-1}>{!shelf ? "Welcome to NClude Audiobooks Library" : "Book Shelf"}</h1>
          </header>
          {/* <div className='flex items-center justify-center mt-6'>
          <h1 className='text-2xl'>Welcome to I-Stem Library</h1>
        </div> */}

          {/* <div className="border-2 border-white px-12 py-4 my-8">
            <nav
              aria-label="Browse selection navigation region"
              className="d-flex"
            >
              <button
                className={`py-4 mr-12 ${
                  displayStatus === "all"
                    ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                    : ""
                }`}
                onClick={handleAllBooksDisplay}
              >
                Browse All Books
              </button>
              <button
                className={`py-4 mr-12 ${
                  displayStatus === "category"
                    ? "text-[#9AFE43] border-b-2 border-[#9AFE43]"
                    : ""
                }`}
                onClick={handleCategoryBooksDisplay}
              >
                Books By Category
              </button>
              <button
                className="try-doc-access btn bookshelf-btn"
                onClick={() => {
                  // navigate("/bookshelf");
                  setShelf(!shelf);
                  if(displayStatus!=='shelf') {
                    setDisplayStatus("shelf");
                  } else {
                    setDisplayStatus('all');
                  }
                  
                }}
              >
                {shelf?'Library':'BookShelf'}
              </button>
            </nav>
          </div> */}
          {shelf && <BookShelf />}
          {!shelf && <header className="">
            {/* <div className="search-div">
              <form
                className="d-flex search-form"
                role="search"
                onSubmit={handleBookSearch}
              >
                <label htmlFor="searchInput" className="visually-hidden">
                  Search books, topic, author
                </label>
                <input
                  id="searchInput"
                  className="form-control me-2 search-input"
                  type="search"
                  placeholder="Search books, topic, author"
                  aria-label="Search books, topic, author"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <button className="btn search-btn" type="submit">
                  Search
                </button>
              </form>
            </div> */}

            {/* new search div */}
            <div style={{ width: "100%", height: "fit-content", marginTop: "5rem" }} className="d-flex  justify-between items-center">
              <div className="d-flex justify-center items-center category-header"><h2>Choose one category</h2></div>
              <div className="newsDropdownContainer " style={{ width: '25%' }}>


                {/* Source Dropdown */}
                {/* <div className="input-div-search">
          <h2 id="output-format" className="form-label sr-only">
          Search books, topic, author...
          </h2>
          <input
            className="form-control"
            id="searchInput"
            name="searchInput"
            aria-label="Search books, topic, author..."
            placeholder="Search books, topic, author..."
            value={searchQuery}
            onChange={(e: any) => setSearchQuery(e.target.value)}
            aria-labelledby="Search books, topic, author"
            required
          />
        </div> */}
                <div className="input-div-search">
                  <label id="output-format" className="form-label sr-only" htmlFor="language">
                    Select Language
                  </label>
                  <select
                    className="form-control input-6"
                    id="language"
                    name="language"
                    aria-label="Select Language"
                    value={selectedLanguage}
                    onChange={(event: any) => {
                      const lang = event.target.value;
                      localStorage.setItem('currentLanguage', lang);
                      setSelectedLanguage(lang)
                    }}
                    aria-labelledby="language"
                    required
                  >
                    <option key='hindi' value='Hindi'>
                      Hindi
                    </option>
                    <option key='english' value='English'>
                      English
                    </option>
                  </select>
                </div>
                {/* <div className="input-div-search">
            <h2 id="output-format" className="form-label sr-only">
              Books by Category
            </h2>
            <select
              className="form-control"
              id="book-category"
              name="book-category"
              aria-label="Books by Category"
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
              aria-labelledby="book-category"
              required
            >
              <option value="">
              Books by Category
              </option>
              {categories.map((category, index) => (
                  <option value={category} key={index}>
                    {category}
                  </option>
                ))}
            </select>
          </div> */}
                {/* <button className="input-search-btn" onClick={()=> handleBookSearch() }>Search</button> */}
              </div>
            </div>

            {/* <input className='w-[300px] h-[40px] text-black rounded px-4' placeholder='Search Book ,topic ,author' value={searchQuery} onChange={(e)=>{setSearchQuery(e.target.value)}}/>
        <button className='bg-[#A643FE] w-[100px] h-[40px] rounded' onClick={handleBookSearch}>Search</button> */}
          </header>}
          {/* {!shelf && displayStatus==="category" && <h2 className='text-[24px] d-flex center'>Category Books</h2>}
          {!shelf && displayStatus === "category" && (
            <div className="text-black flex justify-center items-center my-4">
              <select
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
                className="w-[400px] h-[40px] rounded"
                aria-label="select book category"
              >
                <option value="">Select a category</option>
                {categories.map((category, index) => (
                  <option value={category} key={index}>
                    {category}
                  </option>
                ))}
              </select>
              <button
                className="bg-[blueviolet] w-[150px] h-[40px] text-white rounded"
                onClick={handleCategorySearch}
              >
                Submit
              </button>
            </div>
          )} */}
          {!shelf && <div className="">
            {/* <BookList title={title} books={books} /> */}
            <CategoryPage selectedLanguage={selectedLanguage} />
          </div>}
          {/* {!shelf && <Pagination
            pageNumber={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />} */}
        </div>
      </div>
    </div>
  );
};

export default Library;
